<template>
  <div class="rj-col-3">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        订单日期：
      </div>
      <div class="rj-baseinfo__item">
        {{ form.creattime }}
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { parseTime } from '@/libs/util';
export default {
  data () {
    return {};
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {},
  computed: {},
  methods: {},
  mounted () {
    this.$set(this.form, 'creattime', parseTime(Date.now(), '{y}-{m}-{d} {h}:{i}:{s}'));
  }
};
</script>
